<div class="carousel-container">
  <div class="carousel-wrapper" [style.width]="width + 'px'" >
    <div class="carousel" [attr.startPress]="startPress" [style.transition]="startPress > 0 ? 'none' : '-webkit-transform 500ms'"
      [style.webkitTransition]="startPress > 0 ? 'none' : '-webkit-transform 500ms'" [style.transform]="'translateX('+amount+'px)'"
      [style.webkitTransform]="'translateX('+amount+'px)'"
      [style.width]="(items.length * width) + 'px'"
     
      #carousel>

      <div *ngFor="let item of items; let i = index" 
      [class.active-carousel-item]="childIndex === i"
      [style.width]="(width-(margin*2))+'px'" 
      [style.margin-left]="margin + 'px'"
      [style.margin-right]="margin + 'px'">

        <ng-template [ngTemplateOutlet]="$item" [ngTemplateOutletContext]="{$implicit: item, index: i}"></ng-template>

      </div>
    </div>
  </div>
  <!--
  <div class="controls" >
    <button class="prev"  (click)="scroll(false, carousel)" [disabled]="childIndex === 0">
            <app-gphc-icon [disabled]="childIndex === 0" [iconType]="'prev'" [offset]="'none'"></app-gphc-icon>
    </button>

    <button class="next"  (click)="scroll(true, carousel)" 
    [disabled]="childIndex >= items.length-1">
           <app-gphc-icon [disabled]="childIndex >= items.length-1" [iconType]="'next'" [offset]="'none'"></app-gphc-icon>
          </button>
  </div>
        -->
</div>